export default "__VITE_ASSET__ExnpNbr6__"